import { createEl } from "@/client/utils/createEl";

export const downloadFile = (file: File): void => {
    const blobUrl = URL.createObjectURL(file);
    const anchorEl = createEl("a", "", [], (anchor) => {
        anchor.href = blobUrl;
        anchor.download = file.name;
    });
    anchorEl.click();
    URL.revokeObjectURL(blobUrl);
};
